import React, { useCallback } from 'react';

import { MarchDishShield } from 'app/components/ui/Elements/MarchShield';

import { DishVideoSlide } from './DishVideoSlide';
import { DishPictureSlide } from './DishPictureSlide';

import { MediaContentContext, Slide } from './dishMediaContent.types';

import s from './dish-media-content.module.scss';


type DishSlideProps = {
    id: string,
    context: MediaContentContext,
    currentSlideIndex: number,
    index: number,
    slide: Slide,
    autoPlay?: boolean,
    onClickOpenDetails: (slide: Slide) => void, // eslint-disable-line no-unused-vars
};


export function DishSlide({
    id,
    context,
    currentSlideIndex,
    slide,
    index,
    autoPlay = false,
    onClickOpenDetails,
}: DishSlideProps) {
    const {
        type,
        imageUrl,
        imageUrlDesktop,
        src,
        srcDesktop,
    } = slide;

    const handlClickOnOpenDetails = useCallback(() => {
        onClickOpenDetails(slide);
    }, [onClickOpenDetails, slide]);

    const img = imageUrl ?? imageUrlDesktop;
    const imgDesktop = imageUrlDesktop ?? imageUrl;

    const isImgSlide = type === 'img' && img && imgDesktop;
    const isVideoSlide = type === 'video' && src;

    return (
        <div>
            <div className={s.slideRelativeWrapper}>
                {id && (
                    <div className="land-march-dish-label-wrapper">
                        <MarchDishShield
                            // @ts-ignore
                            dishId={id}
                        />
                    </div>
                )}
                {isImgSlide && (
                    <DishPictureSlide
                        context={context}
                        alt={slide.alt}
                        imageUrl={img}
                        imageUrlDesktop={imgDesktop}
                        onClickOpenDetails={handlClickOnOpenDetails}
                    />
                )}
                {isVideoSlide && (
                    <DishVideoSlide
                        src={src}
                        srcDesktop={srcDesktop}
                        isActive={index + 1 === currentSlideIndex}
                        context={context}
                        autoPlay={autoPlay}
                        onClickOpenDetails={handlClickOnOpenDetails}
                    />
                )}
            </div>
        </div>
    );
}
